export default __webpack_public_path__ + "static/media/logoFooter.22ec52e5.png";